import { defineMessages } from 'react-intl'

const scope = `procurify.platform.iam.features.grant-report-access.UseGrantReportAccessPresenter`

export default defineMessages({
  errorToastTitle: {
    id: `${scope}.errorToastTitle`,
    defaultMessage: 'Error',
  },
  errorToastDefaultMessage: {
    id: `${scope}.errorToastDefaultMessage`,
    defaultMessage: 'Unable to give the user report access. Please try again.',
  },
})
